"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.determineEnabledIntegrations = exports.loadIntegrations = exports.ONE_TRUST_SEGMENT_MAPPING = void 0;
exports.ONE_TRUST_SEGMENT_MAPPING = {
    C0001: ['Performance Monitoring', 'Raw Data'],
    C0002: [
        'A/B Testing',
        'Analytics',
        'Attribution',
        'Email Marketing',
        'Feature Flagging',
        'Heatmaps & Recordings',
        'Marketing Automation',
        'Personalization',
        'Tag Managers',
    ],
    C0003: [],
    C0004: ['Advertising', 'Referrals', 'Other'],
};
const loadIntegrations = (_a) => __awaiter(void 0, [_a], void 0, function* ({ writeKey, host = 'cdn.segment.com', }) {
    const result = yield window.fetch(`https://${host}/v1/projects/${writeKey}/integrations`);
    return result.json();
});
exports.loadIntegrations = loadIntegrations;
const determineEnabledIntegrations = (consentGroups, integrations) => {
    const enabledIntegrations = {};
    for (let group of consentGroups) {
        const segmentCategories = exports.ONE_TRUST_SEGMENT_MAPPING[group];
        if (!segmentCategories) {
            continue;
        }
        for (let category of segmentCategories) {
            for (let integration of integrations) {
                if (integration.category === category) {
                    enabledIntegrations[integration.creationName] = true;
                }
            }
        }
    }
    if (consentGroups.includes('C0001')) {
        enabledIntegrations['Amazon S3'] = true;
        enabledIntegrations['AWS S3'] = true;
        enabledIntegrations['Segment.io'] = true;
    }
    if (consentGroups.includes('C0002')) {
        enabledIntegrations['Optimizely Conversion (smava)'] = true;
        enabledIntegrations['Optimizely Experimentation (smava)'] = true;
    }
    enabledIntegrations['All'] = false;
    return enabledIntegrations;
};
exports.determineEnabledIntegrations = determineEnabledIntegrations;
//# sourceMappingURL=segmentIntegrations.js.map